import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import Checkbox from "@mui/material/Checkbox";
import React, {useState} from "react";
import {useDealContext} from "../../contexts/DealContext";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import classnames from "classnames";
import CustomCurrencyInput from "../../components/CustomCurrencyInput";
import useDidMountEffect from "../../hooks/useDidMountEffect";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Popover from "@mui/material/Popover";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const initialState = {
    external_id: null,
    name: '',
    amount: null,
    description: 'CUSTOM REBATE',
    is_applied: false,
    is_taxed: true,
    is_capped: false,
    is_compatible: true,
    is_custom: true,
    original_rebate: {},
}

export const CreateRebateItem = ({dealState, setDealStateWithUpdate}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })
    const { updateDealResponse } = useDealContext()
    const [createRebateState, setCreateRebateState] = useState(initialState)

    const handleClick = (event) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useDidMountEffect(function addRebate() {
        if (createRebateState.is_applied) {
            let newDealState = structuredClone(dealState)
            const allRebates = dealState.formatted_quote.rebates
            newDealState.formatted_quote.rebates = allRebates.concat(createRebateState)
            setDealStateWithUpdate(newDealState, true)
            setCreateRebateState(initialState)
        }
    }, [createRebateState.is_applied])

    const isLoading = updateDealResponse?.loading
    const isDisabled = isLoading || !createRebateState.name || !createRebateState.amount

    return (
        <TableRow key={'10011'}>
            <TableCell
                align="left"
                width={isTabletOrMobile ? '10%' : '25%'}
            >
                <input
                    className=""
                    type="text"
                    value={createRebateState.name}
                    placeholder={isTabletOrMobile ? 'Custom': 'Custom Rebate Name'}
                    onChange={(e) => setCreateRebateState({...createRebateState, name: e.target.value})}
                />
            </TableCell>
            <TableCell
                align="right"
                width={isTabletOrMobile ? '5%' : '25%'}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: "row",
                        alignItems: 'center',
                        justifyContent: 'end',
                    }}
                >
                    <CustomCurrencyInput
                        onChange={(value) => setCreateRebateState({...createRebateState, amount: value})}
                        className={classnames('payment-row_value custom-fee-input', {
                            loading: isLoading
                        })}
                        value={createRebateState.amount}
                        InputProps={isTabletOrMobile ? {} : undefined}
                    />
                    {
                        isTabletOrMobile &&
                        <div

                        >
                            <MoreVertIcon onClick={handleClick}/>
                            <Popover
                                // id={id}
                                onClick={(e) => e.stopPropagation()}
                                open={Boolean(anchorEl)}
                                anchorEl={anchorEl}
                                onClose={handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    horizontal: 'right',
                                    vertical: 'top'
                                }}
                            >
                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        padding: "5px 10px"
                                    }}
                                >
                                    <Typography>
                                        Applied
                                    </Typography>
                                    <Checkbox
                                        className={classnames('payment-row_value', {
                                            isDisabled: isLoading || !createRebateState.is_applied,
                                        })}
                                        onChange={() => setCreateRebateState({
                                            ...createRebateState,
                                            is_applied: !createRebateState.is_applied
                                        }, true)}
                                        checked={createRebateState.is_applied}
                                        disabled={isLoading}
                                    />
                                </Stack>
                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    style={{
                                        padding: "5px 10px"
                                    }}
                                >
                                    <Typography>
                                        Taxed
                                    </Typography>
                                    <Checkbox
                                        className={classnames('payment-row_value', {
                                            isDisabled: isLoading || !createRebateState.is_applied,
                                        })}
                                        onChange={() => setCreateRebateState({
                                            ...createRebateState,
                                            is_taxed: !createRebateState.is_taxed
                                        }, true)}
                                        checked={createRebateState.is_applied && createRebateState.is_taxed}
                                        disabled={isLoading || !createRebateState.is_applied}
                                    />
                                </Stack>
                            </Popover>
                        </div>
                    }
                </div>
            </TableCell>
            {
                !isTabletOrMobile &&
                <React.Fragment>
                    <TableCell
                        align="right"
                        width={isTabletOrMobile ? '5%' : '10%'}
                    >
                        <Checkbox
                            className={'payment-row_value'}
                            onChange={(value) => setCreateRebateState({...createRebateState, is_applied: !createRebateState.is_applied})}
                            checked={createRebateState.is_applied}
                            disabled={isDisabled}
                        />
                    </TableCell>

                    <TableCell
                        align="right"
                        width={isTabletOrMobile ? '5%' : '10%'}
                    >
                        <Checkbox
                            className={'payment-row_value'}
                            onChange={(value) => setCreateRebateState({...createRebateState, is_taxed: !createRebateState.is_taxed})}
                            checked={createRebateState.is_taxed}
                            disabled={isDisabled}
                        />
                    </TableCell>
                </React.Fragment>
            }
        </TableRow>
    )
}